<template>
    <ProductCard
        product-type="hotel"
        :product-image="productData.info?.image_large_url"
        :product-link="'/psf/' + productData.info.slug"
        :product-name="productData.name"
        :product-stars-rating="productData.overview.rating_by_customers.outOfFiveFraction"
        :product-rating="productData.overview.rating_by_customers.accurate"
        :product-rating-count="productData.overview.surveys_count"
        :product-shuttle-free="productData.info?.shuttle_free"
        :product-shuttle-free-only="true"
        card-type="HotelPopularCard"
    />
</template>

<script setup lang="ts">
import ProductCard from '../ProductCard.vue';
import type { IHotelProduct } from '@nuxt-monorepo/ui/types';
const { productData } = defineProps<{ productData: IHotelProduct }>();
</script>

<style scoped lang="postcss"></style>
